import AuthenticatedLayout from '../Layouts/AuthenticatedLayout';
import Lottie from "lottie-react";
import lottie_main_animation from "../images/lottie_main.json";
import RegularButton from '../Components/RegularButton';
import { Head } from '@inertiajs/react';

export default function Home({ auth }) {
    return (
        <AuthenticatedLayout
            user={auth.user}
            header="Home"
        >
            <Head title="Home" />

            <div className="py-12">
                <div className="w-full mx-auto px-6 lg:px-12">
                    <div className="bg-white overflow-hidden shadow-md sm:rounded-lg">
                        <div className="p-6">
                            <div className="flex items-center justify-center">
                                <div className="flex flex-col items-center justify-center w-full gap-8 px-8">
                                    <h3 className="text-xl lg:text-4xl text-center mx-auto text-slate-400">
                                        Welcome {auth.user.name}
                                    </h3>

                                    <RegularButton
                                    href={route('tenant.create')}
                                    className="bg-emerald-500 hover:bg-emerald-400 focus:bg-emerald-300 active:bg-emerald-600 focus:ring-emerald-300">
                                        Quick Start
                                    </RegularButton>

                                    <div className="lg:container mx-auto lg:w-1/2 h-auto">
                                        <Lottie animationData={lottie_main_animation} />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AuthenticatedLayout>
    );
}
